import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const AddressContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.palette.text.light};
  margin-bottom: ${({ theme }) => theme.spacing}px;
  li {
    padding-bottom:${({ theme }) => theme.spacing / 2}px;
  }
`;

const Address = ({ address }) => (
  address && (
  <AddressContainer className="Address">
    {
      (address.house_name)
      && (
        <li>
          <span>{address.house_name}</span>
          ,
        </li>
      )
    }
    <li>
      <span>
        {
        [address.house_flat_number, address.street]
          .filter((s) => !!s)
          .join(' ')
        }
      </span>
      ,
    </li>
    <li>
      <span>{address.town_city}</span>
      {
        address.postcode
        && (
          <span>
            ,&nbsp;
            <span>{address.postcode}</span>
          </span>
        )
      }
    </li>
  </AddressContainer>
  )
);

Address.propTypes = {
  address: PropTypes.shape({
    address_type: PropTypes.string,
    country: PropTypes.string,
    county: PropTypes.string,
    town_city: PropTypes.string,
    district: PropTypes.string,
    house_flat_number: PropTypes.string,
    house_name: PropTypes.string,
    street: PropTypes.string,
    postcode: PropTypes.string,
    is_default: PropTypes.bool,
  }).isRequired,
};

export default Address;
